var _style, _path, _path2, _path3, _circle, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodKetone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blood-ketone_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.08 38.91c0-3.65-6.6-12.68-6.6-12.68s-6.61 9-6.61 12.68a6.61 6.61 0 0013.21 0z",
    transform: "translate(-.91 -1.87)",
    fill: "#ff6d3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.87,
    d: "M47.96 94.96l-9.77 5.64-24.33-14.05V64.19M18.82 55.58L38.19 44.4l14.38 8.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.87,
    d: "M38.19 44.41v-28.1L62.53 2.25 81.9 13.44M86.87 22.05v23.9M38.19 16.31L24.78 8.77M20.36 1.44a5 5 0 11-5 5 5 5 0 015-5zM1.44 58.45a12.43 12.43 0 0112.41-12.42"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.85,
    cy: 58.45,
    r: 5.74,
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.87 3.89a12.43 12.43 0 0112.41 12.42M86.87 10.57a5.74 5.74 0 105.74 5.74 5.74 5.74 0 00-5.74-5.74zM13.85 86.55l-6.49 3.71M7.85 93.44a3.31 3.31 0 10-4.24 2 3.32 3.32 0 004.24-2zM77.81 77.67V58.13h0a2.47 2.47 0 002.48-2.47v-4H58.85v4a2.47 2.47 0 002.47 2.47h0v19.54",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.87
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.69 88.4h-9.9a5.36 5.36 0 01-5.37-5.36h0a5.36 5.36 0 015.37-5.37h21.85M67.4 99.13h-8.31a5.36 5.36 0 01-5.37-5.37h0M67.4 109.88h-4.77a5.37 5.37 0 01-5.37-5.37h0M112.44 111.9c-9.89-.21-11.77.59-11.77.59a53.6 53.6 0 00-5.6 1.49c-9.69 3.12-16.53 4.81-26.7 5.07h-2.48a5.38 5.38 0 01-5.37-5.37h0M77.64 65.34l1.61-.21a19.32 19.32 0 0113.53 3.22c2.51 1.72 5.35 3.79 8 6 0 0 5.26 5.33 11.69 5.33M60.52 113.72v-3.84M57.27 104.51v-5.69M122.03 73.6h-6.55a3 3 0 00-3 3v38.3a3 3 0 003 3h6.55M53.71 93.77v-5.78M61.32 58.13h5.08",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.87
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#17c2c9",
    d: "M43.94 39.75h5.82V23.33l12.45-7.02V9.07L43.94 19.62v20.13zM38.19 93.96v-7.41L25.5 79.66V66.85h-5.9v16.38l18.59 10.73z"
  })));
}
export default SvgBloodKetone;